import { defineStore } from 'pinia'

// 定义用户状态存储
export const useUserStore = defineStore('user', {
  // 状态初始化
  state: () => ({
    userId: localStorage.getItem('userId') || null, // 从本地存储读取用户ID
    userName: localStorage.getItem('userName') || null, // 从本地存储读取用户名
    avatars: localStorage.getItem('avatars') , //存头像
    tel:localStorage.getItem('tel'),
    token: localStorage.getItem('token') || null, // 存储登录令牌
    isLogin: !!localStorage.getItem('token'), // 是否登录（根据token判断）
    userInfo: null // 存储用户详细信息（如权限、角色等）
  }),

  // 计算属性（类似Vuex的getters）
  getters: {
    // 获取当前用户ID
    getUserId: (state) => state.userId,
    // 获取当前用户名
    getUserName: (state) => state.userName,
    //获取用户头像
    getAvatars : (state) => state.avatars,
    // 判断是否已登录
    isAuthenticated: (state) => state.isLogin,
    //获取手机号
    getTel:(state)  => state.tel,
  },


  actions: {

    initAuth() {
      const getCookie = (name) => {
        const nameEQ = `${name}=`;
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === ' ') c = c.substring(1);
          if (c.indexOf(nameEQ) === 0) return decodeURIComponent(c.substring(nameEQ.length));
        }
        return null;
      };

      const token = getCookie('HTTP_USER_TOKEN');
      
      if (token) {
        this.token = token;
        this.isLogin = true;
        
        // 从localStorage恢复用户信息
        const userInfoStr = localStorage.getItem('userInfo');
        const userInfo = JSON.parse(userInfoStr || '{}');
        this.userId = userInfo.userId;
        this.userName = userInfo.userName;
        this.userInfo = userInfo;
        this.tel = userInfo.tel;
      } else {
        console.warn('[userStore] Cookie中未找到Token,用户未登录');
      }
    },
    
    // 登录成功后保存用户信息
    loginSuccess(userData) {
      const { userId, userName, token,avatars,tel, ...rest } = userData
      this.userId = userId
      this.userName = userName
      this.token = token
      this.isLogin = true
      this.userInfo = rest
      this.avatars = avatars 
      this.tel = tel

      // 持久化到本地存储
      localStorage.setItem('userId', userId)
      localStorage.setItem('userName', userName)
      localStorage.setItem('avatars',avatars)
      localStorage.setItem('token', token)
      localStorage.setItem('tel', tel)
    },

    // 退出登录
    logout() {
      // 清空状态
      this.userId = null
      this.userName = null
      this.token = null
      this.isLogin = false
      this.userInfo = null
      this.avatars = null 
      this.tel = null 

      // 清除本地存储
      localStorage.removeItem('userId')
      localStorage.removeItem('userName')
      localStorage.removeItem('token')
      localStorage.removeItem('avatars')
      localStorage.removeItem('tel')
      // 跳转到登录页
      //router.push('/login')
    },

    // 更新用户信息
    updateUserInfo(info) {
      this.userInfo = { ...this.userInfo, ...info }
    }
  }
})